/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Snackbar from '@material-ui/core/Snackbar';

import CustomDropdown from "../CustomDropdown/CustomDropdown.jsx";

import CustomNotification from "../../views/LandingPage/Sections/CustomNotification";

import headerLinksStyle from "../../assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";

import { logoutUser } from '../../actions/authActions';

class HeaderLinks extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: ''
        };
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onLogout = e => {
        e.preventDefault();
        // WithRouter nos permite pasar this.props.history como parámetro
        this.props.logoutUser(this.props.history);
    };

    render() {
        const { classes, dropdownHoverColor, authReducer } = this.props;
        const { isAuthenticated, user } = authReducer;

        // Already Logged-User links in main menu
        const loggedItems = (
            <CustomDropdown
                noLiPadding
                navDropdown
                hoverColor={dropdownHoverColor}
                buttonText={ `Hola ${user.first_name}` }
                buttonProps={{ className: classes.navLink, color: "transparent" }}
                // buttonIcon={ViewCarousel}
                dropdownList={[
                    <Link to="/profile" className={classes.dropdownLink}>
                        Mi perfil
                    </Link>,
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScvDOuhSve7BusqSi8Frfq7qRiJe4kekV2-FdkB3mpj_DRNoA/viewform"
                        className={classes.dropdownLink}
                        target="_blank"
                        rel="external nofollow"
                    >
                        Tu opinión cuenta
                    </a>,
                    <a href="#" onClick={this.onLogout} className={classes.dropdownLink}>
                        Cerrar sesión
                    </a>
                ]}
            />
        );

        // Login links in main menu
        const noLoggedItems = (
            <CustomDropdown
                noLiPadding
                navDropdown
                hoverColor={dropdownHoverColor}
                buttonText="Zona Usuarios"
                buttonProps={{ className: classes.navLink, color: "transparent" }}
                // buttonIcon={ViewCarousel}
                /*<Link to="/login-owner" className={classes.dropdownLink}>
                    Propietarios
                </Link>,*/
                /**
                 TODO: Construir la vista Login Propietarios
                 */
                dropdownList={[
                    <Link to="/login" className={classes.dropdownLink}>
                        Iniciar sesión
                    </Link>,
                    <Link to="/signup" className={classes.dropdownLink}>
                        Registro
                    </Link>,
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScvDOuhSve7BusqSi8Frfq7qRiJe4kekV2-FdkB3mpj_DRNoA/viewform"
                        className={classes.dropdownLink}
                        target="_blank"
                        rel="external nofollow"
                    >
                        Tu opinión cuenta
                    </a>
                ]}
            />
        );

        /**
         * TODO: Implementar una vista en la cual se puedan reportar problemas técnicos
         * */

        return (
            <List className={classes.list + " " + classes.mlAuto}>
                {/* Custom Notification */}
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                    <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                </Snackbar>
                {/* End Custom Notification */}

                <ListItem className={classes.listItem}>
                    <CustomDropdown
                        noLiPadding
                        navDropdown
                        hoverColor={dropdownHoverColor}
                        buttonText="Inicio"
                        buttonProps={{ className: classes.navLink, color: "transparent" }}
                        // buttonIcon={Apps}

                        /**
                         TODO: Construir la vista Login Propietarios
                         */
                        /*<Link to="/blog" className={classes.dropdownLink}>
                                Blog
                            </Link>,
                            */
                        dropdownList={[
                            <Link to="/" className={classes.dropdownLink}>
                                Inicio
                            </Link>,
                            <Link to="/contenido-360" className={classes.dropdownLink}>
                                Contenido 360
                            </Link>
                        ]}
                    />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <CustomDropdown
                        noLiPadding
                        navDropdown
                        hoverColor={dropdownHoverColor}
                        buttonText="Alojamientos"
                        buttonProps={{ className: classes.navLink, color: "transparent" }}
                        // buttonIcon={ViewDay}
                        /*<Link to="/booking-tutorial-accommodations" className={classes.dropdownLink}>
                                Cómo reservar
                            </Link>*/
                        dropdownList={[
                            <Link to="/accommodations" className={classes.dropdownLink}>
                                Alojamientos
                            </Link>
                        ]}
                    />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <CustomDropdown
                        noLiPadding
                        navDropdown
                        hoverColor={dropdownHoverColor}
                        buttonText="Tours"
                        buttonProps={{ className: classes.navLink, color: "transparent" }}
                        // buttonIcon={ViewCarousel}
                        dropdownList={[
                            <Link to="/tours" className={classes.dropdownLink}>
                                Tours
                            </Link>
                            /*<Link to="/booking-tutorial-tours" className={classes.dropdownLink}>
                                Cómo reservar
                            </Link>*/
                        ]}
                    />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <CustomDropdown
                        noLiPadding
                        navDropdown
                        hoverColor={dropdownHoverColor}
                        buttonText="Quienes somos"
                        buttonProps={{ className: classes.navLink, color: "transparent" }}
                        // buttonIcon={ViewCarousel}
                        dropdownList={[
                            <Link to="/quienes-somos" className={classes.dropdownLink}>
                                La Empresa
                            </Link>,
                            <Link to="/contacto" className={classes.dropdownLink}>
                                Contacto
                            </Link>,
                            <Link to="/terminos-y-condiciones" className={classes.dropdownLink}>
                                Términos y Condiciones
                            </Link>
                        ]}
                    />
                </ListItem>
                <ListItem className={classes.listItem}>
                    {isAuthenticated ? loggedItems : noLoggedItems}
                </ListItem>
            </List>
        );
    }
}

HeaderLinks.defaultProps = {
    hoverColor: "primary"
};

HeaderLinks.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    dropdownHoverColor: PropTypes.oneOf([
        "dark",
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "rose"
    ])
};

const mapStateToProps = state => ({
    authReducer: state.authReducer
});

export default connect(mapStateToProps, { logoutUser })( withRouter( withStyles(headerLinksStyle)(HeaderLinks) ) );



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx